import type {
  Block,
  Document,
  Inline,
  Text,
  TopLevelBlock
} from '@contentful/rich-text-types';
import { isDefined } from '~/utils/guards/isDefined';
import getPathFromKey from '~/utils/richtext/getPathFromKey';

export default function isChildOf(
  type: string,
  key: string,
  richText: Document
) {
  return isTypeOnPath(type, getPathFromKey(key), 0, richText);
}

const isTypeOnPath = (
  type: string,
  path: number[],
  depth: number,
  richText: Document
) => {
  if (getNodeFromPath(path, depth, 0, richText).nodeType === type) {
    return true;
  }

  if (depth !== path.length + 1) {
    return isTypeOnPath(type, path, depth + 1, richText);
  }

  return false;
};

const getNodeFromPath = (
  path: number[],
  depth: number,
  counter: number,
  parentNode: Document | TopLevelBlock | Block | Inline | Text | undefined
): { nodeType: string } => {
  if (
    !isDefined(parentNode) ||
    !('content' in parentNode) ||
    !isDefined(parentNode?.content?.[path[counter]])
  ) {
    return { nodeType: 'invalid' };
  }

  if (counter !== depth - 1) {
    return getNodeFromPath(
      path,
      depth,
      counter + 1,
      parentNode?.content?.[path[counter]]
    );
  }

  return parentNode?.content?.[path[counter]];
};
